import { LocalizedAttributesValue } from 'src/generated/operations.ts';

export const isRecommendedAccessory = (
    item?: LocalizedAttributesValue | null,
) => item && (item.raw || []).includes('1');
